import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import TabList, { ITabItem } from "../../../yoello-lib/modules/components/UI/Tabs/TabList";
import Filters from "../../menu/products/Filters";
import { setFilterCriteria, setTab } from "../state/OrderParentActions";
import { OrderTabs } from "../state/OrderParentReducer";
import { OrderButtons } from "./OrderButtons";
import Styles from './OrderBar.module.scss';
import { useTranslation } from "react-i18next";
import { OrderKeys } from "../OrderParentContainer";

interface IOrderActionBarProps {
    orderLists: any;
    selectedTab: string;
    dispatch: any;
    filters: any;
    orderKey: OrderKeys;
    isPickupNow: boolean;
}

export function OrderActionBar({
    orderLists,
    selectedTab,
    dispatch,
    filters,
    orderKey,
    isPickupNow
}: IOrderActionBarProps) {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { t } = useTranslation();
    const tabList: ITabItem[] = useMemo(() => {
        return [
            {
                id: OrderTabs.ALL,
                label: t(`forms.orders.tabs.${orderKey === "newOrders" ? "allNew" : "allOpen"}`),
                value: OrderTabs.ALL,
            },
            {
                id: OrderTabs.DINE_IN,
                label: t("forms.orders.tabs.dineIn"),
                value: OrderTabs.DINE_IN,
                counter: orderLists.dineIn.length,
            },
            {
                id: OrderTabs.DELIVERY,
                label: t("forms.orders.tabs.delivery"),
                value: OrderTabs.DELIVERY,
                counter: orderLists.delivery.length,
            },
            {
                id: OrderTabs.COLLECTION,
                label: t("forms.orders.tabs.collection"),
                value: OrderTabs.COLLECTION,
                counter: orderLists.collection.length,
            }
        ]
        // eslint-disable-next-line
    }, [orderLists, orderKey]);

    function onChangeTab(value: any) {
        dispatch(setTab(value));
    }

    function onChangeFilter(filters: any, filterCritera: any) {
        dispatch(setFilterCriteria(filterCritera));
    }

    return <div>
        <div className={Styles.OrderTopBar}>
            <TabList tabs={tabList} defaultTab={OrderTabs.ALL} onChange={onChangeTab} level="primary" selectedTab={selectedTab} />
            <div className={Styles.OrderButtons}>
                <OrderButtons orderKey={orderKey} orderList={orderLists[selectedTab]} selectedTab={selectedTab} isPickupNow={isPickupNow} />
                {filters[selectedTab] && <Filters
                    key={selectedTab}
                    defaultFilters={{}}
                    filterkey={`order-filters-${selectedVenueId}-${selectedTab}`}
                    allFilters={filters[selectedTab]}
                    setFilterState={onChangeFilter}
                    filterTitle={""}
                />}
            </div>
        </div>
    </div>
}